import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import './EnterpriseSuggestedActionsPlaceholder.styles.scss';

type EnterpriseSuggestedActionsPlaceholderProps = {
  count?: number;
};

const COMMON: Partial<IContentLoaderProps> = {
  backgroundColor: '#e7f1fc',
  foregroundColor: '#ffffff',
};

// A single fixed-viewBox loader can't stretch to full width without either
// centering itself (leaving gaps) or distorting the round avatar, so each row
// mirrors the real item's flex layout: a fixed avatar, a stretchy text block
// (preserveAspectRatio="none" lets the bars fill the row) and a fixed button.
const SuggestedActionItemPlaceholder: React.FC = () => (
  <div className="enterprise-suggested-actions-placeholder__row">
    <ContentLoader
      className="enterprise-suggested-actions-placeholder__avatar"
      viewBox="0 0 48 48"
      {...COMMON}
    >
      <circle cx="24" cy="24" r="24" />
    </ContentLoader>

    <ContentLoader
      className="enterprise-suggested-actions-placeholder__text"
      viewBox="0 0 400 40"
      preserveAspectRatio="none"
      {...COMMON}
    >
      <rect x="0" y="2" rx="2" ry="2" width="180" height="16" />
      <rect x="0" y="26" rx="2" ry="2" width="320" height="12" />
    </ContentLoader>

    <ContentLoader
      className="enterprise-suggested-actions-placeholder__button"
      viewBox="0 0 140 28"
      {...COMMON}
    >
      <rect x="0" y="0" rx="6" ry="6" width="104" height="28" />
      <circle cx="126" cy="14" r="14" />
    </ContentLoader>
  </div>
);

const EnterpriseSuggestedActionsPlaceholder: React.FC<
  EnterpriseSuggestedActionsPlaceholderProps
> = ({ count = 10 }) => (
  <div className="enterprise-suggested-actions-placeholder">
    {Array.from({ length: count }).map((_, index) => (
      <SuggestedActionItemPlaceholder key={index} />
    ))}
  </div>
);

export default EnterpriseSuggestedActionsPlaceholder;
